import {
  NormalMultipleFixedInputFields,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const HomeBusinessSetupSectionFormField = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeLang === "en";
  }, [activeLang]);

  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-6-business-setup-heading"
        fieldName="home-section-6-business-setup-heading"
        placeholderText="Heading"
        inputValue={
          stateDetails?.["home-section-6-business-setup-heading"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Description"
        fieldId="home-section-6-business-setup-description"
        fieldName="home-section-6-business-setup-description"
        placeholderText="Description"
        inputValue={
          stateDetails?.["home-section-6-business-setup-description"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />

      {/* 3 Process Fixed Fields */}
      <NormalMultipleFixedInputFields
        stateDetails={stateDetails}
        isFetching={isFetching}
        allFilesResponse={allFilesResponse}
        labelText="Process"
        fieldId="home-section-6-business-setup-process"
        searchValue={searchValue}
        selectedFileType={selectedFileType}
        adminRole={adminRole}
        permissionsList={permissionsList}
        handleImageChange={onChangeImage}
        handleTextInputChange={handleTextInputChange}
        // handleTextEditorInputChange={handleTextEditorInputChange}
        translateField={true}
        extraContainerClasses="mt-5"
        cards={[
          {
            card_id: "business-process-card-1",
            types: ["IMAGE", "TEXT", "TEXT"],
            is_hidden: [isHideInOtherLanguages, true, true],
            ids_name: ["logo_field_id", "text_filed_id_1", "text_filed_id_2"],
            placeholders_name: [
              "",
              "text_filed_placeholder_1",
              "text_filed_placeholder_2",
            ],
            // IDs
            logo_field_id: "home-section-6-business-process-logo-1",
            text_filed_id_1: "home-section-6-business-process-title-1",
            text_filed_id_2: "home-section-6-business-process-description-1",
            // Placeholders
            text_filed_placeholder_1: "Title",
            text_filed_placeholder_2: "Description",
          },
          {
            card_id: "business-process-card-2",
            types: ["IMAGE", "TEXT", "TEXT"],
            is_hidden: [isHideInOtherLanguages, true, true],
            ids_name: ["logo_field_id", "text_filed_id_1", "text_filed_id_2"],
            placeholders_name: [
              "",
              "text_filed_placeholder_1",
              "text_filed_placeholder_2",
            ],
            // IDs
            logo_field_id: "home-section-6-business-process-logo-2",
            text_filed_id_1: "home-section-6-business-process-title-2",
            text_filed_id_2: "home-section-6-business-process-description-2",
            // Placeholders
            text_filed_placeholder_1: "Title",
            text_filed_placeholder_2: "Description",
          },
          {
            card_id: "business-process-card-3",
            types: ["IMAGE", "TEXT", "TEXT"],
            is_hidden: [isHideInOtherLanguages, true, true],
            ids_name: ["logo_field_id", "text_filed_id_1", "text_filed_id_2"],
            placeholders_name: [
              "",
              "text_filed_placeholder_1",
              "text_filed_placeholder_2",
            ],
            // IDs
            logo_field_id: "home-section-6-business-process-logo-3",
            text_filed_id_1: "home-section-6-business-process-title-3",
            text_filed_id_2: "home-section-6-business-process-description-3",
            // Placeholders
            text_filed_placeholder_1: "Title",
            text_filed_placeholder_2: "Description",
          },
        ]}
      />
    </>
  );
};

export default HomeBusinessSetupSectionFormField;
